/* LAB PROFILE */
export const GET_LAB_PAYMENTS = "GET_LAB_PAYMENTS";
export const GET_LAB_PAYMENTS_SUCCESS = "GET_LAB_PAYMENTS_SUCCESS";
export const GET_LAB_PAYMENTS_FAIL = "GET_LAB_PAYMENTS_FAIL";

export const UPDATE_LAB_PAYMENTS = "UPDATE_LAB_PAYMENTS";
export const UPDATE_LAB_PAYMENTS_SUCCESS = "UPDATE_LAB_PAYMENTS_SUCCESS";
export const UPDATE_LAB_PAYMENTS_FAIL = "UPDATE_LAB_PAYMENTS_FAIL";
